import { Tooltip } from 'react-tooltip';
import { ProfilePermissions } from 'reduxStore/reducers/ProfileSlice/types';
import { getDateWithTimezone, prepareFilterData } from 'utils/helpers';
import {
  GenerateInvitationTableHeadingsProps,
  InvitationFiltersFormValues,
} from './InvitationFiltersForm/types';
import { Button } from 'ui/redesign/Button';
import { ButtonVariant } from 'ui/redesign/Button/constants';
import classNames from 'classnames';
import { InvitationCooperateStatusDto } from 'services/InvitationService/types';
import { MultiValue, SingleValue } from 'react-select';
import { OptionType } from 'ui/redesign/Select/types';

type Status = {
  name: string;
  description: string;
};

export const GenerateInvitationTableHeadings = ({
  permissions,
  resendInvite,
}: GenerateInvitationTableHeadingsProps): TableHeading[] => {
  return [
    {
      attributeName: 'fullName',
      name: 'ФИО Исполнителя',
      renderColumn: (column) => <span className="w-[100px] break-words">{column as string}</span>,
    },
    {
      attributeName: 'creationTime',
      name: 'Дата создания',
      renderColumn: (column) => (
        <span className="whitespace-nowrap">
          {getDateWithTimezone(String(column), undefined, 'dd.MM.yyyy HH:mm')}
        </span>
      ),
    },
    {
      attributeName: 'lastModificationTime',
      name: 'Дата изменения статуса',
      renderColumn: (column) => (
        <span className="whitespace-nowrap">
          {getDateWithTimezone(String(column), undefined, 'dd.MM.yyyy HH:mm')}
        </span>
      ),
    },
    {
      attributeName: 'status',
      name: 'Статус приглашения',
      renderColumn: (column, rowData) => {
        const status = rowData.status as Status;
        return (
          <>
            <span
              className="whitespace-nowrap"
              data-tooltip-id="statuses-tooltip"
              data-tooltip-content={String(status.description)}
            >
              {status.name as string}
            </span>
            <Tooltip id="statuses-tooltip" place="bottom" style={{ zIndex: 9999 }} />
          </>
        );
      },
    },
    {
      attributeName: 'email',
      name: 'E-mail',
      renderColumn: (column) => <span className="w-[100px] break-all">{column as string}</span>,
    },
    {
      attributeName: 'status',
      name: 'Действие',
      renderColumn: (column, rowData) => {
        if (
          permissions?.includes(ProfilePermissions.Invitation_InvitationsCooperate_Resend) &&
          ((rowData.status as InvitationCooperateStatusDto).name === 'Просрочено' ||
            (rowData.status as InvitationCooperateStatusDto).name === 'Ошибка отправки')
        ) {
          return (
            <Button
              variant={ButtonVariant.GHOST}
              className={classNames(
                'cursor-pointer whitespace-nowrap text-center text-primary-100',
                {
                  'cursor-not-allowed text-primary-40': rowData.unavailableReason,
                }
              )}
              onClick={() =>
                resendInvite({
                  id: rowData.id as string,
                  concurrencyStamp: rowData.concurrencyStamp as string,
                })
              }
            >
              ОТПРАВИТЬ ПОВТОРНО
            </Button>
          );
        } else {
          return <div className="whitespace-nowrap"></div>;
        }
      },
    },
  ];
};

export const prepareFilters = (filters: InvitationFiltersFormValues) => {
  const statusesValues = filters.statuses
    ? prepareFilterData(
        filters.statuses as unknown as MultiValue<OptionType> | SingleValue<OptionType>
      )
    : null;

  return {
    createDate: filters.createDate,
    fullName: filters.fullName,
    email: filters.email,
    statuses: statusesValues,
  };
};